

exports.__esModule = true;
exports.$ShoppingCartRoute = undefined;

require('./directive');

var _squid = require('squid');

var $ShoppingCartRoute = exports.$ShoppingCartRoute = _squid.$ComponentRoute.extend('$ShoppingCartRoute', {

    path: 'shoppingCart',

    directive: 'xo-shoppingcart-page',

    query: ['noUpdateRequired'],

    trackingData: {
        fptiState: 'shoppingCart',
        templateName: 'shoppingCart.dust',
        pageGoal: 'shoppingCart page',
        buzname: {
            'fullpage': {
                'pagename': '%::fullpage-shoppingCart',
                'pagename2': '%::fullpage-shoppingCart:wps:shoppingcart:',
                'version': 'member:%:'
            }
        },
        trackStateExit: true
    },

    auth: false,

    children: []
});

angular.value("$ShoppingCartRoute", $ShoppingCartRoute);
_squid.$ComponentRoute;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-shoppingcart/route.js
// module id = ./pages/xo-shoppingcart/route.js
// module chunks = 1